import { createStore } from "vuex";
import AuthService from "../services/AuthService";

export default createStore({
  state: {
    user: null,
    isAuthenticated: false,
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
      state.isAuthenticated = !!user;
    },
  },
  actions: {
    async register({ commit }, userData) {
      try {
        const user = await AuthService.register(userData);
        commit("SET_USER", user);
        return user;
      } catch (error) {
        commit("SET_USER", null);
        throw error;
      }
    },
    async login({ commit }, { email, password }) {
      try {
        const user = await AuthService.login(email, password);
        commit("SET_USER", user);
        return user;
      } catch (error) {
        commit("SET_USER", null);
        throw error;
      }
    },
    logout({ commit }) {
      AuthService.logout();
      commit("SET_USER", null);
    },
    initAuth({ commit }) {
      const user = AuthService.getCurrentUser();
      commit("SET_USER", user);
    },
    async updateProfile({ commit }, profileData) {
      const updatedUser = await AuthService.updateProfile(profileData);
      // Update the user in the store
      const user = AuthService.getCurrentUser();
      commit("SET_USER", user);
      return updatedUser;
    },
  },
  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    currentUser: (state) => state.user,
  },
});
